/**
 * apiTarget.js
 * Single switch for where API calls go: DataQuad Cloud or the local sidecar.
 *
 * Wiring into dataService.js is a two-line diff because API_BASE_URL is a
 * module-level binding read at call time inside template literals:
 *
 *   // before
 *   const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
 *
 *   // after
 *   import { getApiBase, getApiToken } from './apiTarget';
 *   let API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
 *   export function setApiBase(url) { API_BASE_URL = url; }
 *
 * Then in the project activation path (Projects.js onProjectSelect and
 * WelcomeLanding recent cards):
 *
 *   if (project.storage_mode === 'local') {
 *     const engine = await startLocalEngine();
 *     setApiBase(engine.baseUrl);
 *     setLocalToken(engine.token);
 *   } else {
 *     setApiBase(process.env.REACT_APP_API_URL);
 *     setLocalToken(null);
 *   }
 *
 * authHeaders() gains one line: prefer the sidecar token when in local mode.
 *
 * Files that keep their own hardcoded API_BASE_URL and stay pinned to cloud
 * on purpose: ProjectSharing.js, TeamManagement.js (org features are
 * cloud-only), login/reset/subscription pages, Pulse.
 */

const CLOUD_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

let mode = 'cloud';            // 'cloud' | 'local'
let localBase = null;
let localToken = null;

export function activateCloud() {
  mode = 'cloud';
}

export function activateLocal(baseUrl, token) {
  mode = 'local';
  localBase = baseUrl;
  localToken = token;
}

export function getApiBase() {
  return mode === 'local' && localBase ? localBase : CLOUD_BASE;
}

export function getApiToken() {
  // Local mode: per-launch sidecar token. Cloud mode: the login JWT.
  if (mode === 'local' && localToken) return localToken;
  return localStorage.getItem('token') || '';
}

export function isLocalMode() {
  return mode === 'local';
}
